<div class="spinner-background">
  <soft-loading-spinner></soft-loading-spinner>
  <div class="c column center mt-5">
    <h5 class="font-semibold loading-text">{{ '#APPLICATION.COMPONENTS.BLOCKING_LOADING_SPINNER.LOADING' | translate }}</h5>
    <div class="loading-desc">{{ '#APPLICATION.COMPONENTS.BLOCKING_LOADING_SPINNER.LOADING_DESC' | translate }}</div>
  </div>
</div>
